import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ApiClientService } from "~app/common/services/api-client.service";
import { ObjectUtils } from "~app/common/utils/object-utils";

@Injectable({
    providedIn: "root"
})
export class MapCalculationService {
    private readonly http = inject(ApiClientService);

    getArea(wktstring: string, wktStringsForClipping?: string[]): Observable<number> {
        const body = {
            makeValidIfPossible: true,
            wktString: wktstring,
            wktStringsForClipping: wktStringsForClipping
        };
        return this.http.post(`/Geometry/ValidateAndGetArea`, body, true).pipe(map((r: any) => r.area));
    }

    calculateHektarFromArea(area: number, numberOfDecimals = 2): number {
        let hektar = 0;
        if (ObjectUtils.hasValue(area) && area !== 0) {
            hektar = ((area / 100) / 100);
            hektar = Number(hektar.toFixed(numberOfDecimals));
        }
        return hektar;
    }

    getLength(wktString: string): Observable<number> {
        const body = {
            wktString: wktString,
            makeValidIfPossible: true
        };
        return this.http.post(`/Geometry/ValidateAndGetLength`, body, true).pipe(map((r: any) => r.length));
    }

    getDmsFromDegrees(deg) {
        let d = Math.floor(deg);
        const minfloat = (deg - d) * 60;
        let m = Math.floor(minfloat);
        const secfloat = (minfloat - m) * 60;
        let s = Math.round(secfloat);
        if (s === 60) {
            m++;
            s = 0;
        }
        if (m === 60) {
            d++;
            m = 0;
        }
        return (`${d}°${m}'${s}"`);
    }
}
